(function () {
  const links_with_image = () => {
    let containers = document.querySelectorAll(".links-with-image");

    containers.forEach((container) => {
      const id = container.closest("section").getAttribute("id");
      let images = container.querySelectorAll(
        ".links-with-image__image-wrapper"
      );
      let links = container.querySelectorAll(".links-with-image__placeholder");

      images.forEach((image, index) => {
        let isFirst = index === 0;

        image.style.opacity = isFirst ? 1 : 0;
        image.style.zIndex = isFirst ? 1 : 0;
        image.style.transition = "opacity 1s ease";
      });

      let fadeImages = (e, index) => {
        links.forEach((link) => {
          let parent = link.parentElement;
          let isActiveParent = parent === links[index].parentElement;

          parent.classList.toggle("active", isActiveParent);
        });

        images.forEach((image, i) => {
          let isCurrent = i === index;

          image.style.opacity = isCurrent ? 1 : 0;
          image.style.zIndex = isCurrent ? 1 : 0;
        });
      };

      links.forEach((link, index) => {
        link.addEventListener("mouseenter", (e) => fadeImages(e, index));
        link.addEventListener("focusin", (e) => fadeImages(e, index));
      });

      container.addEventListener("mouseleave", (e) => fadeImages(e, 0));
      container.addEventListener("focusout", (e) => {
        if (!container.contains(e.relatedTarget)) fadeImages(e, 0);
      });

      const initSwiper = () => {
        if (
          document.querySelector(`#${id} .links-with-image--mobile.overlay`) !==
          null
        ) {
          //overlay layout mobile Swiper
          const linksSwiper = new Swiper(`#${id} .links-with-image--mobile`, {
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: { crossFade: true },
            loop: true,
            speed: 800,
            allowTouchMove: true,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            mousewheel: {
              forceToAxis: true,
            },
            keyboard: {
              enabled: false,
            },
            pagination: {
              el: container.querySelector(".swiper-pagination"),
              type: "fraction",
            },
          });
        } else {
          //left and right layouts mobile swiper
          const linksOrdinarySwiper = new Swiper(
            `#${id} .links-with-image--mobile:not(.overlay)`,
            {
              slidesPerView: 1.1,
              slidesPerGroup: 1,
              spaceBetween: 10,
              loop: true,
              speed: 800,
              allowTouchMove: true,
              watchSlidesProgress: true,
              preventInteractionOnTransition: true,
              centeredSlides: true,
              centeredSlidesBounds: true,
              mousewheel: {
                forceToAxis: true,
              },
              keyboard: {
                enabled: false,
              },
              pagination: {
                el: container.querySelector(".swiper-pagination"),
                type: "fraction",
              },
            }
          );
        }
      };

      initSwiper();
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    links_with_image();
    document.addEventListener("shopify:section:load", function () {
      links_with_image();
    });
  });
})();
